// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InventoryModal_hide_modal__ikAYx {
  visibility: hidden; }

.InventoryModal_modal__zgh13 {
  width: 90vw;
  height: 95vh;
  padding: 20px;
  justify-content: start;
  display: flex;
  flex-direction: row;
  padding: 0;
  overflow-y: auto;
  overflow-x: hidden; }
  .InventoryModal_modal__zgh13 .InventoryModal_header__MmG4I {
    display: flex;
    align-items: center;
    justify-content: space-between; }
    .InventoryModal_modal__zgh13 .InventoryModal_header__MmG4I .InventoryModal_title__l\\+JXy {
      font-weight: 600;
      font-size: 24px;
      line-height: 150%;
      color: var(--HightEmphasis); }
    .InventoryModal_modal__zgh13 .InventoryModal_header__MmG4I svg {
      cursor: pointer; }
  .InventoryModal_modal__zgh13 .InventoryModal_form__5KvDY {
    max-width: 320px;
    min-width: 320px;
    overflow: scroll;
    padding: 20px;
    border-right: 1px solid #e0e0e0; }
  .InventoryModal_modal__zgh13 .InventoryModal_content__P\\+Q83 {
    margin-top: 15px; }
    .InventoryModal_modal__zgh13 .InventoryModal_content__P\\+Q83 form {
      display: flex;
      flex-direction: column;
      border-bottom: 1px solid #e0e0e0;
      border-top: 1px solid #e0e0e0;
      padding-top: 15px;
      padding-bottom: 30px; }
    .InventoryModal_modal__zgh13 .InventoryModal_content__P\\+Q83 .InventoryModal_supplies_form__dwRJS {
      border: 0;
      padding-top: 0;
      padding-bottom: 0;
      position: relative; }
      .InventoryModal_modal__zgh13 .InventoryModal_content__P\\+Q83 .InventoryModal_supplies_form__dwRJS .InventoryModal_input_add_suppliers__1vXyE {
        position: absolute; }
        .InventoryModal_modal__zgh13 .InventoryModal_content__P\\+Q83 .InventoryModal_supplies_form__dwRJS .InventoryModal_input_add_suppliers__1vXyE .InventoryModal_add_suppliers_link__4GZpH {
          color: var(--Orange);
          cursor: pointer; }
        .InventoryModal_modal__zgh13 .InventoryModal_content__P\\+Q83 .InventoryModal_supplies_form__dwRJS .InventoryModal_input_add_suppliers__1vXyE span {
          font-weight: 400;
          font-size: 12px;
          line-height: 24px;
          color: var(--LowEmphasis); }
    .InventoryModal_modal__zgh13 .InventoryModal_content__P\\+Q83 .InventoryModal_levels__LDIbd {
      display: flex;
      justify-content: space-between;
      margin-top: 40px; }
    .InventoryModal_modal__zgh13 .InventoryModal_content__P\\+Q83 .InventoryModal_input__biqWb:not(:first-child) {
      margin-top: 40px; }
    .InventoryModal_modal__zgh13 .InventoryModal_content__P\\+Q83 .InventoryModal_button__U6LDc {
      margin-top: 30px;
      align-self: flex-end; }

.InventoryModal_modalCoordContainer__04QTs {
  width: calc(100% - 320px);
  height: 100%;
  background-color: #f5f5f5;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between; }

.InventoryModal_area__DFWqs {
  display: flex;
  position: relative;
  height: max-content;
  width: 100%;
  background-color: #f5f5f5; }
  .InventoryModal_area__DFWqs .InventoryModal_image_container__8qHFp {
    position: relative;
    width: max-content; }
    .InventoryModal_area__DFWqs .InventoryModal_image_container__8qHFp .InventoryModal_newCoordinates__UBIAs {
      position: absolute;
      z-index: 5;
      background-color: #ffffff40; }
    .InventoryModal_area__DFWqs .InventoryModal_image_container__8qHFp .InventoryModal_draw__R\\+saj {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%; }
    .InventoryModal_area__DFWqs .InventoryModal_image_container_img__uWCkZ {
      height: 100%;
      width: 100%;
      object-fit: contain;
      object-position: top left; }
  .InventoryModal_area__DFWqs .InventoryModal_scale__dKlKl {
    position: absolute;
    bottom: 20px;
    right: 20px;
    color: #ffffff;
    z-index: 100;
    cursor: pointer;
    transition: all 0.4s; }
  .InventoryModal_area__DFWqs .InventoryModal_remove__1VA51 {
    position: absolute;
    top: 20px;
    right: 20px;
    height: 50px;
    width: 20px;
    height: 20px;
    cursor: pointer;
    transition: all 0.4s;
    z-index: 101;
    color: white;
    transform: translate(43px, -43px);
    opacity: 10 !important; }
    .InventoryModal_area__DFWqs .InventoryModal_remove__1VA51:hover {
      color: #dad72f; }

.InventoryModal_footer__60uuE {
  gap: 10px;
  height: 81px;
  width: 100%;
  padding: 10px 30px 20px 10px;
  background-color: #ffffff;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  position: relative; }
  .InventoryModal_footer__text__FdZDb {
    position: absolute;
    top: 10px;
    left: 10px;
    font-weight: 600;
    font-size: 14px; }
    .InventoryModal_footer__text__FdZDb span {
      color: red; }

.InventoryModal_oldCoord__25kYa {
  position: absolute;
  top: 0;
  left: 0;
  width: 20px;
  height: 20px;
  cursor: pointer;
  background: rgba(33, 33, 33, 0.6);
  color: #ffffff;
  border: 1px solid #666666;
  font-weight: 400;
  font-size: 8px;
  line-height: 9px; }

.InventoryModal_response__BnaqK {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 4000;
  display: flex;
  align-items: center;
  justify-content: center; }
  .InventoryModal_response__BnaqK > div {
    padding: 42px 22px 100px 22px;
    background-color: #ffffff;
    box-shadow: rgba(0, 0, 0, 0.24) 0 3px 8px; }
    .InventoryModal_response__BnaqK > div p {
      font-style: normal;
      font-weight: 600;
      font-size: 24px;
      line-height: 150%; }
  .InventoryModal_response__BnaqK .InventoryModal_icons__XXxmH {
    width: 40px;
    height: 40px;
    color: green; }

.InventoryModal_ifClose__n-bBD {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.205);
  z-index: 3000;
  display: flex;
  align-items: center;
  justify-content: center; }
  .InventoryModal_ifClose__container__6Ihvg {
    min-height: 360px;
    min-width: 560px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 10px 20px;
    background: #ffffff;
    box-shadow: 0 0 8px rgba(68, 87, 104, 0.25);
    border-radius: 4px; }
  .InventoryModal_ifClose__header__14Jps h2 {
    font-weight: 700;
    font-size: 18px;
    line-height: 150%; }
  .InventoryModal_ifClose__header__14Jps span {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px; }
  .InventoryModal_ifClose__footer__ayQ-\\+ {
    display: flex;
    justify-content: flex-end;
    gap: 20px; }
    .InventoryModal_ifClose__footer__ayQ-\\+ button {
      width: 53px;
      padding: 5px 0;
      border-radius: 4px;
      border: none;
      transition: all 0.3s;
      cursor: pointer; }
    .InventoryModal_ifClose__footer_yes__N1zDg {
      background: #fe6100;
      color: #ffffff; }
      .InventoryModal_ifClose__footer_yes__N1zDg:hover {
        background: #8e3600; }
    .InventoryModal_ifClose__footer_no__F-rsR {
      background: inherit; }
      .InventoryModal_ifClose__footer_no__F-rsR:hover {
        background: #fe6100;
        color: #ffffff; }
  .InventoryModal_ifClose__n-bBD .InventoryModal_icons__XXxmH {
    width: 40px;
    height: 40px;
    color: green; }

.InventoryModal_close__9Hj7U {
  position: absolute;
  right: 40px;
  top: 20px; }

.InventoryModal_modalHide__dKW9G {
  position: absolute;
  top: -50000px; }

.InventoryModal_button_cancel__vwpjn {
  background: #ffffff;
  color: #fe6100; }
  .InventoryModal_button_cancel__vwpjn:hover {
    background: #fe6100;
    color: #ffffff; }

.InventoryModal_scaleble__1LnwO {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #000000f0;
  z-index: 99999; }
  .InventoryModal_scaleble__area__v-9gL {
    display: flex;
    justify-content: center;
    position: relative;
    width: 100%;
    height: max-content; }
  .InventoryModal_scaleble__container__MFbzx {
    position: relative;
    width: max-content; }
  .InventoryModal_scaleble__1LnwO img {
    max-width: 95vw;
    max-height: 95vh; }
  .InventoryModal_scaleble__close__0rN6q {
    position: absolute;
    bottom: calc(20px);
    right: calc(20px); }

.InventoryModal_addCamera__5Ydwr {
  margin-top: 40px;
  text-align: center;
  padding: 10px;
  border-radius: 4px;
  background: var(--Orange);
  color: var(--White);
  border: none;
  transition: all 0.4s;
  text-decoration: none; }
  .InventoryModal_addCamera__5Ydwr:hover {
    background: var(--SaddleBrown); }

.InventoryModal_algorithm__8lwv4 {
  width: 100%;
  padding: 0 0 23px 0; }
  .InventoryModal_algorithm__8lwv4 h2 {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 8px;
    display: flex;
    gap: 8px;
    align-items: baseline;
    transition: all 0.4s; }
    .InventoryModal_algorithm__8lwv4 h2 svg {
      cursor: pointer;
      fill: #666666; }
      .InventoryModal_algorithm__8lwv4 h2 svg:hover {
        fill: #2c2c2c; }
  .InventoryModal_algorithm__image__iOMcO {
    position: fixed;
    top: 170px;
    left: 170px;
    z-index: 9999; }
  .InventoryModal_algorithm__container__LCQww {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 9998; }
  .InventoryModal_algorithm__toggle__1RuAT {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px 10px;
    border-radius: 4px;
    border: 1px solid var(--product-on-surface-divider, #e0e0e0);
    background: #f3f4f6; }
    .InventoryModal_algorithm__toggle_container__Y6DmW {
      display: flex;
      flex-direction: column;
      gap: 2px; }
    .InventoryModal_algorithm__toggle_type__ktX7t {
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      color: #666666; }
    .InventoryModal_algorithm__toggle_title__sT\\+uR {
      font-size: 12px;
      font-style: normal;
      font-weight: 600;
      line-height: 150%;
      color: #9e9e9e; }
  .InventoryModal_algorithm__8lwv4 .InventoryModal_no_info_for_suppliers__mnASB span {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px; }
  .InventoryModal_algorithm__8lwv4 .InventoryModal_no_info_for_suppliers__mnASB .InventoryModal_no_info_link__ntD89 {
    color: var(--Orange);
    cursor: pointer; }

.InventoryModal_email_settings__-1W\\+8 {
  display: flex;
  width: 280px;
  height: 50px;
  align-items: center;
  padding: 5px 10px;
  justify-content: space-between;
  background-color: #f3f4f6;
  border: 1px solid #e0e0e0;
  border-radius: 4px; }
  .InventoryModal_email_settings__-1W\\+8 h6 {
    font-weight: 600;
    font-size: 12px;
    line-height: 150%;
    color: var(--LowEmphasis); }
  .InventoryModal_email_settings__-1W\\+8 .InventoryModal_send_to_box__hPaL8 {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    width: 210px; }
  .InventoryModal_email_settings__-1W\\+8 .InventoryModal_email_settings_list__JjU7H {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: #666666; }

.InventoryModal_typeModal__Ps0XN {
  width: 80vw;
  height: max-content;
  max-height: 90vh;
  padding: 20px; }
  .InventoryModal_typeModal__container__lpxNp {
    display: flex;
    flex-direction: column; }
    .InventoryModal_typeModal__container__lpxNp h2 {
      color: var(--surface-on-surface-high-emphasis, #212121);
      font-family: Inter;
      font-size: 24px;
      font-style: normal;
      font-weight: 600;
      line-height: 150%;
      /* 36px */
      letter-spacing: 0.72px; }
  .InventoryModal_typeModal__select__xY2jA {
    width: 100%;
    height: max-content;
    display: flex;
    transition: all 0.4s;
    justify-content: space-between; }
    .InventoryModal_typeModal__select__xY2jA h3 {
      color: var(--product-on-surface-high-emphasis, #212121);
      /* product/Headline 3 */
      font-family: Inter;
      font-size: 18px;
      font-style: normal;
      font-weight: 700;
      line-height: 150%;
      /* 27px */
      letter-spacing: 0.54px; }
    .InventoryModal_typeModal__select__xY2jA p {
      color: var(--product-on-surface-mediun-emphasis, #666);
      /* product/Body 2 */
      font-family: Inter;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px;
      /* 171.429% */
      letter-spacing: 0.1px; }
    .InventoryModal_typeModal__select_item__Ju-Np {
      padding: 10px;
      width: 31%;
      height: 100%;
      background: #ffffff;
      cursor: pointer; }
      .InventoryModal_typeModal__select_item__Ju-Np:hover {
        background: rgba(254, 97, 0, 0.1); }
    .InventoryModal_typeModal__select_active__UHW5E {
      background: rgba(254, 97, 0, 0.1); }
    .InventoryModal_typeModal__select_img__WKpVh {
      max-width: 100%;
      object-fit: contain; }
      .InventoryModal_typeModal__select_img__WKpVh svg {
        width: 100%; }
  .InventoryModal_typeModal__footer__9HdtN {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 30px; }

.InventoryModal_zonesSwitcher__xsOSE {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin: 8px; }
`, "",{"version":3,"sources":["webpack://./src/pages/inventory/components/InventoryModal.module.scss","webpack://./src/styles/fonts.scss"],"names":[],"mappings":"AAGA;EACE,kBAAkB,EAAA;;AAGpB;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,kBAAkB,EAAA;EATpB;IAWI,aAAa;IACb,mBAAmB;IACnB,8BAA8B,EAAA;IAblC;MCAE,gBAAgB;MAChB,eAAe;MACf,iBAAiB;MDeb,2BAA2B,EAAA;IAjBjC;MAoBM,eAAe,EAAA;EApBrB;IAwBI,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,+BAA+B,EAAA;EA5BnC;IA+BI,gBAAgB,EAAA;IA/BpB;MAiCM,aAAa;MACb,sBAAsB;MACtB,gCAAgC;MAChC,6BAA6B;MAC7B,iBAAiB;MACjB,oBAAoB,EAAA;IAtC1B;MA0CM,SAAS;MACT,cAAc;MACd,iBAAiB;MACjB,kBAAkB,EAAA;MA7CxB;QAgDQ,kBAAkB,EAAA;QAhD1B;UAmDU,oBAAoB;UACpB,eAAe,EAAA;QApDzB;UC4DE,gBAAgB;UAChB,eAAe;UACf,iBAAiB;UDLT,yBAAyB,EAAA;IAzDnC;MA+DM,aAAa;MACb,8BAA8B;MAC9B,gBAAgB,EAAA;IAjEtB;MAoEM,gBAAgB,EAAA;IApEtB;MAwEM,gBAAgB;MAChB,oBAAoB,EAAA;;AAK1B;EACE,yBAAyB;EACzB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,8BAA8B,EAAA;;AAEhC;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,yBAAyB,EAAA;EAL3B;IAOI,kBAAkB;IAClB,kBAAkB,EAAA;IARtB;MAUM,kBAAkB;MAClB,UAAU;MACV,2BAA2B,EAAA;IAZjC;MAeM,kBAAkB;MAClB,MAAM;MACN,OAAO;MACP,WAAW;MACX,YAAY,EAAA;IAnBlB;MAsBM,YAAY;MACZ,WAAW;MACX,mBAAmB;MACnB,yBAAyB,EAAA;EAzB/B;IA8BI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,cAAc;IACd,YAAY;IACZ,eAAe;IACf,oBAAoB,EAAA;EApCxB;IAuCI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,eAAe;IACf,oBAAoB;IACpB,YAAY;IACZ,YAAY;IACZ,iCAAiC;IACjC,sBAAsB,EAAA;IAlD1B;MAoDM,cAAwB,EAAA;;AAK9B;EACE,SAAS;EACT,YAAY;EACZ,WAAW;EACX,4BAA4B;EAC5B,yBAAyB;EACzB,aAAa;EACb,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB,EAAA;EAClB;IACE,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,eAAe,EAAA;IALhB;MAOG,UAAU,EAAA;;AAIhB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iCAAiC;EACjC,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,gBAAgB,EAAA;;AAGlB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB,EAAA;EAVzB;IAYI,6BAA6B;IAC7B,yBAAyB;IACzB,yCAAyC,EAAA;IAd7C;MAgBM,kBAAkB;MAClB,gBAAgB;MAChB,eAAe;MACf,iBAAiB,EAAA;EAnBvB;IAuBI,WAAW;IACX,YAAY;IACZ,YAAY,EAAA;;AAGhB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB,EAAA;EACvB;IACE,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,2CAA2C;IAC3C,kBAAkB,EAAA;EAEnB;IAEG,gBAAgB;IAChB,eAAe;IACf,iBAAiB,EAAA;EAJpB;IAOG,gBAAgB;IAChB,eAAe;IACf,iBAAiB,EAAA;EAGrB;IACE,aAAa;IACb,yBAAyB;IACzB,SAAS,EAAA;IAHV;MAKG,WAAW;MACX,cAAc;MACd,kBAAkB;MAClB,YAAY;MACZ,oBAAoB;MACpB,eAAe,EAAA;IAEjB;MACE,mBAAmB;MACnB,cAAc,EAAA;MAFf;QAIG,mBAAmB,EAAA;IAGvB;MACE,mBAAmB,EAAA;MADpB;QAIG,mBAAmB;QACnB,cAAc,EAAA;EA1DtB;IA+DI,WAAW;IACX,YAAY;IACZ,YAAY,EAAA;;AAGhB;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS,EAAA;;AAEX;EACE,kBAAkB;EAClB,aAAa,EAAA;;AAEf;EACE,mBAAmB;EACnB,cAAc,EAAA;EAFhB;IAII,mBAAmB;IACnB,cAAc,EAAA;;AAGlB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,2BAA2B;EAC3B,cAAc,EAAA;EACd;IACE,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,mBAAmB,EAAA;EAErB;IACE,kBAAkB;IAClB,kBAAkB,EAAA;EApBtB;IAuBI,eAAe;IACf,gBAAgB,EAAA;EAElB;IACE,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB,EAAA;;AAGrB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,qBAAqB,EAAA;EATvB;IAWI,8BAA8B,EAAA;;AAGlC;EACE,WAAW;EACX,mBAAmB,EAAA;EAFrB;IAII,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,QAAQ;IACR,qBAAqB;IACrB,oBAAoB,EAAA;IAXxB;MAaM,eAAe;MACf,aAAa,EAAA;MAdnB;QAgBQ,aAAa,EAAA;EAInB;IACE,eAAe;IACf,UAAU;IACV,WAAW;IACX,aAAa,EAAA;EAEf;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,aAAa,EAAA;EAEf;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,kBAAkB;IAClB,4DAA4D;IAC5D,mBAAmB,EAAA;IACnB;MACE,aAAa;MACb,sBAAsB;MACtB,QAAQ,EAAA;IAEV;MACE,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,cAAc,EAAA;IAEhB;MACE,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,iBAAiB;MACjB,cAAc,EAAA;EA1DpB;ICrTE,gBAAgB;IAChB,eAAe;IACf,iBAAiB,EAAA;EDmTnB;IAmEM,oBAAoB;IACpB,eAAe,EAAA;;AAKrB;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,8BAA8B;EAC9B,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB,EAAA;EATpB;ICpYE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;ID+Yf,yBAAyB,EAAA;EAb7B;IAiBI,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,YAAY,EAAA;EApBhB;ICxXE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;ID+Yf,cAAc,EAAA;;AAIlB;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,aAAa,EAAA;EACb;IACE,aAAa;IACb,sBAAsB,EAAA;IAFvB;MAIG,uDAAuD;MACvD,kBAAkB;MAClB,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,iBAAiB;MAAE,SAAA;MACnB,sBAAsB,EAAA;EAG1B;IACE,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,oBAAoB;IACpB,8BAA8B,EAAA;IAL/B;MAQG,uDAAuD;MAEvD,uBAAA;MACA,kBAAkB;MAClB,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,iBAAiB;MAAE,SAAA;MACnB,sBAAsB,EAAA;IAhBzB;MAmBG,sDAAsD;MAEtD,mBAAA;MACA,kBAAkB;MAClB,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,iBAAiB;MAAE,aAAA;MACnB,qBAAqB,EAAA;IAEvB;MACE,aAAa;MACb,UAAU;MACV,YAAY;MACZ,mBAAmB;MACnB,eAAe,EAAA;MALhB;QAOG,iCAAiC,EAAA;IAGrC;MACE,iCAAiC,EAAA;IAEnC;MACE,eAAe;MACf,mBAAmB,EAAA;MAFpB;QAIG,WAAW,EAAA;EAKjB;IACE,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,gBAAgB,EAAA;;AAGpB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW,EAAA","sourcesContent":["@import '../../../styles/media.scss';\n@import '../../../styles/fonts.scss';\n\n.hide_modal {\n  visibility: hidden;\n}\n\n.modal {\n  width: 90vw;\n  height: 95vh;\n  padding: 20px;\n  justify-content: start;\n  display: flex;\n  flex-direction: row;\n  padding: 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n  .header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    .title {\n      @include h2;\n      color: var(--HightEmphasis);\n    }\n    svg {\n      cursor: pointer;\n    }\n  }\n  .form {\n    max-width: 320px;\n    min-width: 320px;\n    overflow: scroll;\n    padding: 20px;\n    border-right: 1px solid #e0e0e0;\n  }\n  .content {\n    margin-top: 15px;\n    form {\n      display: flex;\n      flex-direction: column;\n      border-bottom: 1px solid #e0e0e0;\n      border-top: 1px solid #e0e0e0;\n      padding-top: 15px;\n      padding-bottom: 30px;\n    }\n\n    .supplies_form {\n      border: 0;\n      padding-top: 0;\n      padding-bottom: 0;\n      position: relative;\n\n      .input_add_suppliers {\n        position: absolute;\n\n        .add_suppliers_link {\n          color: var(--Orange);\n          cursor: pointer;\n        }\n\n        span {\n          @include caption;\n          color: var(--LowEmphasis);\n        }\n      }\n    }\n\n    .levels {\n      display: flex;\n      justify-content: space-between;\n      margin-top: 40px;\n    }\n    .input:not(:first-child) {\n      margin-top: 40px;\n    }\n\n    .button {\n      margin-top: 30px;\n      align-self: flex-end;\n    }\n  }\n}\n\n.modalCoordContainer {\n  width: calc(100% - 320px);\n  height: 100%;\n  background-color: #f5f5f5;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n.area {\n  display: flex;\n  position: relative;\n  height: max-content;\n  width: 100%;\n  background-color: #f5f5f5;\n  .image_container {\n    position: relative;\n    width: max-content;\n    .newCoordinates {\n      position: absolute;\n      z-index: 5;\n      background-color: #ffffff40;\n    }\n    .draw {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n    }\n    &_img {\n      height: 100%;\n      width: 100%;\n      object-fit: contain;\n      object-position: top left;\n    }\n  }\n\n  .scale {\n    position: absolute;\n    bottom: 20px;\n    right: 20px;\n    color: #ffffff;\n    z-index: 100;\n    cursor: pointer;\n    transition: all 0.4s;\n  }\n  .remove {\n    position: absolute;\n    top: 20px;\n    right: 20px;\n    height: 50px;\n    width: 20px;\n    height: 20px;\n    cursor: pointer;\n    transition: all 0.4s;\n    z-index: 101;\n    color: white;\n    transform: translate(43px, -43px);\n    opacity: 10 !important;\n    &:hover {\n      color: rgb(218, 215, 47);\n    }\n  }\n}\n\n.footer {\n  gap: 10px;\n  height: 81px;\n  width: 100%;\n  padding: 10px 30px 20px 10px;\n  background-color: #ffffff;\n  display: flex;\n  justify-content: flex-end;\n  align-items: flex-end;\n  position: relative;\n  &__text {\n    position: absolute;\n    top: 10px;\n    left: 10px;\n    font-weight: 600;\n    font-size: 14px;\n    span {\n      color: red;\n    }\n  }\n}\n.oldCoord {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n  background: rgba(33, 33, 33, 0.6);\n  color: #ffffff;\n  border: 1px solid #666666;\n  font-weight: 400;\n  font-size: 8px;\n  line-height: 9px;\n}\n\n.response {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(255, 255, 255, 0.7);\n  z-index: 4000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  > div {\n    padding: 42px 22px 100px 22px;\n    background-color: #ffffff;\n    box-shadow: rgba(0, 0, 0, 0.24) 0 3px 8px;\n    p {\n      font-style: normal;\n      font-weight: 600;\n      font-size: 24px;\n      line-height: 150%;\n    }\n  }\n  .icons {\n    width: 40px;\n    height: 40px;\n    color: green;\n  }\n}\n.ifClose {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.205);\n  z-index: 3000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  &__container {\n    min-height: 360px;\n    min-width: 560px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    padding: 10px 20px;\n    background: #ffffff;\n    box-shadow: 0 0 8px rgba(68, 87, 104, 0.25);\n    border-radius: 4px;\n  }\n  &__header {\n    h2 {\n      font-weight: 700;\n      font-size: 18px;\n      line-height: 150%;\n    }\n    span {\n      font-weight: 400;\n      font-size: 16px;\n      line-height: 24px;\n    }\n  }\n  &__footer {\n    display: flex;\n    justify-content: flex-end;\n    gap: 20px;\n    button {\n      width: 53px;\n      padding: 5px 0;\n      border-radius: 4px;\n      border: none;\n      transition: all 0.3s;\n      cursor: pointer;\n    }\n    &_yes {\n      background: #fe6100;\n      color: #ffffff;\n      &:hover {\n        background: #8e3600;\n      }\n    }\n    &_no {\n      background: inherit;\n\n      &:hover {\n        background: #fe6100;\n        color: #ffffff;\n      }\n    }\n  }\n  .icons {\n    width: 40px;\n    height: 40px;\n    color: green;\n  }\n}\n.close {\n  position: absolute;\n  right: 40px;\n  top: 20px;\n}\n.modalHide {\n  position: absolute;\n  top: -50000px;\n}\n.button_cancel {\n  background: #ffffff;\n  color: #fe6100;\n  &:hover {\n    background: #fe6100;\n    color: #ffffff;\n  }\n}\n.scaleble {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #000000f0;\n  z-index: 99999;\n  &__area {\n    display: flex;\n    justify-content: center;\n    position: relative;\n    width: 100%;\n    height: max-content;\n  }\n  &__container {\n    position: relative;\n    width: max-content;\n  }\n  img {\n    max-width: 95vw;\n    max-height: 95vh;\n  }\n  &__close {\n    position: absolute;\n    bottom: calc(20px);\n    right: calc(20px);\n  }\n}\n.addCamera {\n  margin-top: 40px;\n  text-align: center;\n  padding: 10px;\n  border-radius: 4px;\n  background: var(--Orange);\n  color: var(--White);\n  border: none;\n  transition: all 0.4s;\n  text-decoration: none;\n  &:hover {\n    background: var(--SaddleBrown);\n  }\n}\n.algorithm {\n  width: 100%;\n  padding: 0 0 23px 0;\n  h2 {\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 24px;\n    margin-bottom: 8px;\n    display: flex;\n    gap: 8px;\n    align-items: baseline;\n    transition: all 0.4s;\n    svg {\n      cursor: pointer;\n      fill: #666666;\n      &:hover {\n        fill: #2c2c2c;\n      }\n    }\n  }\n  &__image {\n    position: fixed;\n    top: 170px;\n    left: 170px;\n    z-index: 9999;\n  }\n  &__container {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    z-index: 9998;\n  }\n  &__toggle {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 5px 10px;\n    border-radius: 4px;\n    border: 1px solid var(--product-on-surface-divider, #e0e0e0);\n    background: #f3f4f6;\n    &_container {\n      display: flex;\n      flex-direction: column;\n      gap: 2px;\n    }\n    &_type {\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 400;\n      color: #666666;\n    }\n    &_title {\n      font-size: 12px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 150%;\n      color: #9e9e9e;\n    }\n  }\n  .no_info_for_suppliers {\n    span {\n      @include body1;\n    }\n\n    .no_info_link {\n      color: var(--Orange);\n      cursor: pointer;\n    }\n  }\n}\n\n.email_settings {\n  display: flex;\n  width: 280px;\n  height: 50px;\n  align-items: center;\n  padding: 5px 10px;\n  justify-content: space-between;\n  background-color: #f3f4f6;\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n\n  h6 {\n    @include h6;\n    color: var(--LowEmphasis);\n  }\n\n  .send_to_box {\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n    width: 210px;\n  }\n\n  .email_settings_list {\n    @include body2;\n    color: #666666;\n  }\n}\n\n.typeModal {\n  width: 80vw;\n  height: max-content;\n  max-height: 90vh;\n  padding: 20px;\n  &__container {\n    display: flex;\n    flex-direction: column;\n    h2 {\n      color: var(--surface-on-surface-high-emphasis, #212121);\n      font-family: Inter;\n      font-size: 24px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 150%; /* 36px */\n      letter-spacing: 0.72px;\n    }\n  }\n  &__select {\n    width: 100%;\n    height: max-content;\n    display: flex;\n    transition: all 0.4s;\n    justify-content: space-between;\n\n    h3 {\n      color: var(--product-on-surface-high-emphasis, #212121);\n\n      /* product/Headline 3 */\n      font-family: Inter;\n      font-size: 18px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: 150%; /* 27px */\n      letter-spacing: 0.54px;\n    }\n    p {\n      color: var(--product-on-surface-mediun-emphasis, #666);\n\n      /* product/Body 2 */\n      font-family: Inter;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 24px; /* 171.429% */\n      letter-spacing: 0.1px;\n    }\n    &_item {\n      padding: 10px;\n      width: 31%;\n      height: 100%;\n      background: #ffffff;\n      cursor: pointer;\n      &:hover {\n        background: rgba(254, 97, 0, 0.1);\n      }\n    }\n    &_active {\n      background: rgba(254, 97, 0, 0.1);\n    }\n    &_img {\n      max-width: 100%;\n      object-fit: contain;\n      svg {\n        width: 100%;\n      }\n    }\n  }\n\n  &__footer {\n    display: flex;\n    justify-content: flex-end;\n    gap: 10px;\n    margin-top: 30px;\n  }\n}\n.zonesSwitcher{\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  margin: 8px;\n}\n","@mixin h1 {\n  font-weight: 600;\n  font-size: 32px;\n  line-height: 150%;\n}\n\n@mixin h2 {\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 150%;\n}\n\n@mixin h3 {\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n}\n\n@mixin h4 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin h5 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin h6 {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin body1 {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin body2 {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n}\n\n@mixin body3 {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n}\n\n@mixin link1 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin link2 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin caption {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 24px;\n}\n\n@mixin title {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin button {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hide_modal": `InventoryModal_hide_modal__ikAYx`,
	"modal": `InventoryModal_modal__zgh13`,
	"header": `InventoryModal_header__MmG4I`,
	"title": `InventoryModal_title__l+JXy`,
	"form": `InventoryModal_form__5KvDY`,
	"content": `InventoryModal_content__P+Q83`,
	"supplies_form": `InventoryModal_supplies_form__dwRJS`,
	"input_add_suppliers": `InventoryModal_input_add_suppliers__1vXyE`,
	"add_suppliers_link": `InventoryModal_add_suppliers_link__4GZpH`,
	"levels": `InventoryModal_levels__LDIbd`,
	"input": `InventoryModal_input__biqWb`,
	"button": `InventoryModal_button__U6LDc`,
	"modalCoordContainer": `InventoryModal_modalCoordContainer__04QTs`,
	"area": `InventoryModal_area__DFWqs`,
	"image_container": `InventoryModal_image_container__8qHFp`,
	"newCoordinates": `InventoryModal_newCoordinates__UBIAs`,
	"draw": `InventoryModal_draw__R+saj`,
	"image_container_img": `InventoryModal_image_container_img__uWCkZ`,
	"scale": `InventoryModal_scale__dKlKl`,
	"remove": `InventoryModal_remove__1VA51`,
	"footer": `InventoryModal_footer__60uuE`,
	"footer__text": `InventoryModal_footer__text__FdZDb`,
	"oldCoord": `InventoryModal_oldCoord__25kYa`,
	"response": `InventoryModal_response__BnaqK`,
	"icons": `InventoryModal_icons__XXxmH`,
	"ifClose": `InventoryModal_ifClose__n-bBD`,
	"ifClose__container": `InventoryModal_ifClose__container__6Ihvg`,
	"ifClose__header": `InventoryModal_ifClose__header__14Jps`,
	"ifClose__footer": `InventoryModal_ifClose__footer__ayQ-+`,
	"ifClose__footer_yes": `InventoryModal_ifClose__footer_yes__N1zDg`,
	"ifClose__footer_no": `InventoryModal_ifClose__footer_no__F-rsR`,
	"close": `InventoryModal_close__9Hj7U`,
	"modalHide": `InventoryModal_modalHide__dKW9G`,
	"button_cancel": `InventoryModal_button_cancel__vwpjn`,
	"scaleble": `InventoryModal_scaleble__1LnwO`,
	"scaleble__area": `InventoryModal_scaleble__area__v-9gL`,
	"scaleble__container": `InventoryModal_scaleble__container__MFbzx`,
	"scaleble__close": `InventoryModal_scaleble__close__0rN6q`,
	"addCamera": `InventoryModal_addCamera__5Ydwr`,
	"algorithm": `InventoryModal_algorithm__8lwv4`,
	"algorithm__image": `InventoryModal_algorithm__image__iOMcO`,
	"algorithm__container": `InventoryModal_algorithm__container__LCQww`,
	"algorithm__toggle": `InventoryModal_algorithm__toggle__1RuAT`,
	"algorithm__toggle_container": `InventoryModal_algorithm__toggle_container__Y6DmW`,
	"algorithm__toggle_type": `InventoryModal_algorithm__toggle_type__ktX7t`,
	"algorithm__toggle_title": `InventoryModal_algorithm__toggle_title__sT+uR`,
	"no_info_for_suppliers": `InventoryModal_no_info_for_suppliers__mnASB`,
	"no_info_link": `InventoryModal_no_info_link__ntD89`,
	"email_settings": `InventoryModal_email_settings__-1W+8`,
	"send_to_box": `InventoryModal_send_to_box__hPaL8`,
	"email_settings_list": `InventoryModal_email_settings_list__JjU7H`,
	"typeModal": `InventoryModal_typeModal__Ps0XN`,
	"typeModal__container": `InventoryModal_typeModal__container__lpxNp`,
	"typeModal__select": `InventoryModal_typeModal__select__xY2jA`,
	"typeModal__select_item": `InventoryModal_typeModal__select_item__Ju-Np`,
	"typeModal__select_active": `InventoryModal_typeModal__select_active__UHW5E`,
	"typeModal__select_img": `InventoryModal_typeModal__select_img__WKpVh`,
	"typeModal__footer": `InventoryModal_typeModal__footer__9HdtN`,
	"zonesSwitcher": `InventoryModal_zonesSwitcher__xsOSE`
};
export default ___CSS_LOADER_EXPORT___;
